const isUltraSim = (iccid) => {
  return (
    iccid.startsWith("8901260853") ||
    iccid.startsWith("89012401") ||
    iccid.startsWith("89012403")
  );
};

/** Digits-only ICCID for client virtual (T-Mobile J) inventory — must match backend prefix. */
export const PARTNER_ICCID_PREFIX = "890124039";

export const isPartnerIccidDigits = (digits) =>
  typeof digits === "string" &&
  /^\d{19,20}$/.test(digits) &&
  digits.startsWith(PARTNER_ICCID_PREFIX);

export { isUltraSim };
